import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  console.log(params);
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, {encode: false});
    }
  };

  return axios.get(`${url}/workshop/workshop_spare_part_thresholds`, options)
    .then(response => {
      return {
        list: jsona.deserialize(response.data),
        meta: response.data.meta
      };
    });
}

function get(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/workshop/workshop_spare_part_thresholds/${id}`, options)
    .then(response => {
      let spare_part_thresholds = jsona.deserialize(response.data);
      delete spare_part_thresholds.links;
      return spare_part_thresholds;
    });
}

function add(spare_part_thresholds) {
  
  console.log(spare_part_thresholds);
  const payload = jsona.serialize({
    stuff: spare_part_thresholds,
    includeNames: null
  });
  console.log(payload);
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.post(`${url}/workshop/workshop_spare_part_thresholds`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function update(spare_part_thresholds) {
  const payload = jsona.serialize({
    stuff: spare_part_thresholds,
    includeNames: []
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.patch(`${url}/workshop/workshop_spare_part_thresholds/${spare_part_thresholds.id}`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.delete(`${url}/workshop/workshop_spare_part_thresholds/${id}`, options);
}

function list_threshold_master_id(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };
  

  return axios.get(`${url}/workshop/workshop_spare_part_thresholds?filter[spare_part_threshold_master_id]=${id}`, options)
  .then(response => {
    return {
      list: jsona.deserialize(response.data),
      meta: response.data.meta
    };
  });
}

function list_lowest_threshold_master_id(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };
  

  return axios.get(`${url}/workshop/workshop_spare_part_thresholds?filter[lower_threshold]=${id}`, options)
  .then(response => {
    return {
      list: jsona.deserialize(response.data),
      meta: response.data.meta
    };
  });
}


function list_threshold_dealer_id(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/workshop/workshop_spare_part_thresholds?filter[spare_part_threshold_dealer_id]=${id}`, options)
  .then(response => {
    return {
      list: jsona.deserialize(response.data),
      meta: response.data.meta
    };
  });
}


export default {
  list,
  list_threshold_master_id,
  list_lowest_threshold_master_id,
  list_threshold_dealer_id,
  get,
  add,
  update,
  destroy
};

